import pluralize from 'pluralize'

import { IllustratedRow } from '@/components/Chat/ConfirmInfoCard'
import { IllustrationName } from '@/components/icons/Illustration'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useDrivers } from '@/models/driver'
import { useTrailers, useTrucks } from '@/models/equipment'

function count(noun: string, rows: number): string {
  return rows > 0 ? pluralize(noun, rows, true) : `No ${pluralize(noun)}`
}

/** The Equipment card while it's closed: how many of each are on the application. A contractor's are vehicles, with no trailers. */
export function EquipmentSummary({ orgId, contractor }: { orgId: string; contractor?: boolean }) {
  // The rosters' own queries, so opening the card shows these rows without another fetch.
  const { drivers, isLoading: driversLoading } = useDrivers({ orgId, shouldFetchAllPages: true })
  const { trucks, isLoading: trucksLoading } = useTrucks({ orgId, shouldFetchAllPages: true })
  const { trailers, isLoading: trailersLoading } = useTrailers({ orgId, shouldFetchAllPages: true })
  if (driversLoading || trucksLoading || trailersLoading) return <SkeletonRows rows={3} />

  return (
    <div className="flex flex-col gap-3">
      <IllustratedRow
        illustration={IllustrationName.DRIVER}
        label={count('driver', drivers.length)}
        muted={drivers.length === 0}
      />
      <IllustratedRow
        illustration={IllustrationName.TRUCK}
        label={count(contractor ? 'vehicle' : 'truck', trucks.length)}
        muted={trucks.length === 0}
      />
      {!contractor && (
        <IllustratedRow
          illustration={IllustrationName.TRAILER}
          label={count('trailer', trailers.length)}
          muted={trailers.length === 0}
        />
      )}
    </div>
  )
}
